import React, { useState } from 'react'
import styles from "./Sharedproject.module.css"


const Myproject = () => {
    const [projectlen, setProjectLen] = useState(0);

    return (
        <div className={styles.product_page_outer}>
            {projectlen === 0 ?
                <div className={styles.newproject}>
                    <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/newfileicon.svg"} alt='newfile' />
                    <p className={styles.createtext}>
                        No shared projects are there
                    </p>
                </div> :
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <p>Shared Projects</p>
                        {/* <button>+ New Project</button> */}
                    </div>
                    {/* <div className={styles.indivprojectlist}>
                        <div className={styles.indivproject}>
                            <h1>Project Title</h1>
                            <button>Go to editor</button>
                            <hr style={{ borderColor: "#CCCBD3", marginTop: "24px", borderWidth: "1px" }} />
                            <div className={styles.fileactionbtn}>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/edit.png"} alt='rename' /></button>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/settings.png"} alt='settings' /></button>
                                <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='delete' /></button>
                            </div>
                        </div>

                    </div> */}
                </div>
            }

        </div>
    )
}

export default Myproject